import React from 'react';
import { Route } from 'react-router-dom';
import RouteMenu from 'mrf/view/MenuRoute';
import path from 'path';
import NationalTermList from 'components/system/rootTerm/nationalTerm/NationalTermList';
import NationalTermForm from 'components/system/rootTerm/nationalTerm/NationalTermForm';


export default function NationalTerm({ history, match, t, rootTermId }) {
    return (
        <RouteMenu match={match} indexComponent={props => <NationalTermList match={match} rootTermId={rootTermId} t={t} {...props} />}>
            <Route path={path.join(match.url, 'new')} component={props => <NationalTermForm history={history} match={match} rootTermId={rootTermId} t={t} {...props} />} />
            <Route path={path.join(match.url, 'edit/:id')} component={props => <NationalTermForm history={history} match={match} rootTermId={rootTermId} t={t} {...props} />} />
        </RouteMenu>
    );
}